import axios from 'axios';

export default {
    methods: {
        async presupuestoItemStore(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/item', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoItemShow(id, ok, err) {
            try {
                let r = await axios.get('presupuesto/item/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoItemUpdate(d, ok, err) {
            try {
                let r = await axios.put('presupuesto/item/' + d.id, d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoItemLista(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/item/lista', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoItemIndex(d, ok, err) {
            try {
                let r = await axios.get('presupuesto/item?page=' + d.page, {params: d});
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoItemCambiaEstado(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/item/cambia-estado', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoItemConfirma(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/item/confirma', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoItemRevisionList(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/item/revision-list', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoItemRevisionShow(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/item/revision-show', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoItemSolicitudDesc(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/item/solicitud-descuento', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoItemSolicitudPendientes(ok, err) {
            try {
                let r = await axios.post('presupuesto/item/solicitudes-pendientes');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoItemSolicitudAprueba(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/item/solicitud-aprueba', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoItemSolicitudRechaza(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/item/solicitud-rechaza', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoItemVincular(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/item/vincular', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoItemDescuentoGlobal(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/item/descuento-global', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoItemFleteQuita(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/item/flete-quita', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/presupuestoItems.js